<template>
  <div class="query-base-card">
    <component
      :is="componentMapping[deType]"
      v-bind="$options.propsData"
    ></component>
  </div>
</template>

<script>
  import { DATA_ELEMENT_TYPE } from "@/static/global-variables";
  import ContextQuery from "@/components/queries/context-queries/ContextQuery";
  import CRMQuery from "@/components/queries/crm-queries/CRMQuery";
  import OneOneCalculation from "@/components/queries/OneOneCalculation/OneOneCalculation";
  import Today from "@/components/Today";
  import MergeListView from "@/components/queries/merge-list/MergeListView";
  import Now from "@/components/Now";
  import SummarizeView from "@/components/calculations/Summarize/SummarizeView";
  import ObjectTranslationView from "@/components/ObjectTranslationView";
  import FieldTranslationView from "@/components/FieldTranslationView";
  import VmsgView from "@/components/VmsgView";
  import SublistView from "@/components/queries/sublist/SublistView";
  import SortListView from "@/components/queries/sort-list/SortListView";
  import FilterListView from "@/components/queries/filter-list/FilterListView";
  import NitroView from "@/components/queries/nitro-queries/NitroView";
  import SalesView from "@/components/queries/sales-data/SalesView";
  import DropdownView from "@/components/DropdownView";
  import DatepickerView from "@/components/DatepickerView";
  import AlignedTerritoriesView from "@/components/AlignedTerritoriesView";
  import DataEngineView from "@/components/queries/crm-data-engine/DataEngineView";
  import FeedbackOverviewView from "@/components/queries/territory-feedback/FeedbackOverviewView";
  import FeedbackChannelGoalsView from "@/components/queries/territory-feedback/FeedbackChannelGoalsView";
  import FeedbackAccountDataView from "@/components/queries/territory-feedback/FeedbackAccountDataView";
  import FeedbackAccountChannelGoalsView
    from "@/components/queries/territory-feedback/FeedbackAccountChannelGoalsView";
  import FeedbackAccountProductMetricsView
    from "@/components/queries/territory-feedback/FeedbackAccountProductMetricsView";
  import FeedbackProductGoalsView from "@/components/queries/territory-feedback/FeedbackProductGoalsView";
  import FeedbackAccountProductGoalsView
    from "@/components/queries/territory-feedback/FeedbackAccountProductGoalsView";
  import CallAttendeesView from "@/components/CallAttendeesView.vue";

  export default {
    name: "QueryBaseCard",
    components: {
      SummarizeView,
      ContextQuery,
      CRMQuery,
      OneOneCalculation,
      Today,
      MergeListView,
      Now,
      ObjectTranslationView,
      FieldTranslationView,
      VmsgView,
      SortListView,
      FilterListView,
      SublistView,
      NitroView,
      SalesView,
      DropdownView,
      DatepickerView,
      AlignedTerritoriesView,
      DataEngineView,
      FeedbackOverviewView,
      FeedbackChannelGoalsView,
      FeedbackProductGoalsView,
      FeedbackAccountDataView,
      FeedbackAccountChannelGoalsView,
      FeedbackAccountProductGoalsView,
      FeedbackAccountProductMetricsView,
      CallAttendeesView
    },
    props: {
      deId: String,
      deType: String,
      appId: String,
      appType: String
    },
    data() {
      return {
        componentMapping: {
          [DATA_ELEMENT_TYPE.CONTEXT_QUERY]: "context-query",
          [DATA_ELEMENT_TYPE.CRM_QUERY]: "CRM-query",
          [DATA_ELEMENT_TYPE.ONE_FOR_ONE]: "one-one-calculation",
          [DATA_ELEMENT_TYPE.TODAY]: "today",
          [DATA_ELEMENT_TYPE.MERGE_LIST]: "merge-list-view",
          [DATA_ELEMENT_TYPE.NOW]: "now",
          [DATA_ELEMENT_TYPE.SUMMARIZE]: "summarize-view",
          [DATA_ELEMENT_TYPE.OBJECT_TRANSLATION]: "object-translation-view",
          [DATA_ELEMENT_TYPE.FIELD_TRANSLATION]: "field-translation-view",
          [DATA_ELEMENT_TYPE.VEEVA_MESSAGES]: "vmsg-view",
          [DATA_ELEMENT_TYPE.SUBLIST]: "sublist-view",
          [DATA_ELEMENT_TYPE.SORT_LIST]: "sort-list-view",
          [DATA_ELEMENT_TYPE.FILTER_LIST]: "filter-list-view",
          [DATA_ELEMENT_TYPE.NITRO_QUERY]: "nitro-view",
          [DATA_ELEMENT_TYPE.SALES_DATA_QUERY]: "sales-view",
          [DATA_ELEMENT_TYPE.DROPDOWN]: "dropdown-view",
          [DATA_ELEMENT_TYPE.DATEPICKER]: "datepicker-view",
          [DATA_ELEMENT_TYPE.ALIGNED_TERRITORIES]: "aligned-territories-view",
          [DATA_ELEMENT_TYPE.CRM_DATA_ENGINE]: "data-engine-view",
          [DATA_ELEMENT_TYPE.FEEDBACK_OVERVIEW]: "feedback-overview-view",
          [DATA_ELEMENT_TYPE.FEEDBACK_CHANNEL_GOALS]: "feedback-channel-goals-view",
          [DATA_ELEMENT_TYPE.FEEDBACK_PRODUCT_GOALS]: "feedback-product-goals-view",
          [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_DATA]: "feedback-account-data-view",
          [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_CHANNEL_GOALS]: "feedback-account-channel-goals-view",
          [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_GOALS]: "feedback-account-product-goals-view",
          [DATA_ELEMENT_TYPE.FEEDBACK_ACCOUNT_PRODUCT_METRICS]: "feedback-account-product-metrics-view",
          [DATA_ELEMENT_TYPE.CALL_ATTENDEES]: "call-attendees-view"
        }
      };
    }
  };
</script>

<style scoped></style>
